import { PMRProjectSummary } from "../../view/PMRProjectSummary";
import TCDIProjectSummary from "../../view/TCDIProjectSummary";
import { ShouldRenderPMRProjectReport } from "../Validators/ReportValidations";

export const ONE_PAGER_CONFIG = [
    {
        type: 'PMR',
        condition: (productType, productClassification) =>
            ShouldRenderPMRProjectReport(productType, productClassification),
        component: PMRProjectSummary
    },
    {
        type: 'TCDI',
        condition: () => true,
        component: TCDIProjectSummary
    }
];

export const PMR_MOD_REPORT = [0, 1, 2, 3, 4, 5];
export const TCDI_MOD_REPORT = [0, 1, 2, 3];